// extracted by mini-css-extract-plugin
export default {"capabilitiesLabel":"Form_capabilitiesLabel__alBq9","domainsLabel":"Form_domainsLabel__9gDk5"};